// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-JoJAmx","card":"card-sqc3nc"};